// Reducer extracted from PusherModule.js

import update from "immutability-helper";
import { HANDLE_FOCUSED_FIELD, INIT_LOCKED_FIELD } from "./PusherConstants";

// Initial State
const initialState = {
  focusedField: {
    unitPlan: null,
    le: null,
    assessment: null,
    project: null,
  },
  lockedFields: {
    unitPlan: [],
    ayt: [],
  },
  hasPusherPermission: true,
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [HANDLE_FOCUSED_FIELD]: (state, action) => {
    const { type, focusedField, isFocused } = action.data;

    if (!isFocused) {
      state = update(state, {
        focusedField: { [type]: { $set: null } },
      });
    } else {
      state = update(state, {
        focusedField: { [type]: { $set: focusedField } },
      });
    }

    return state;
  },
  [INIT_LOCKED_FIELD]: (state, action) => {
    const { type, lockedFields } = action.data;

    state = update(state, {
      lockedFields: { [type]: { $set: lockedFields } },
    });

    return state;
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
